import React from 'react';
import {
  Container,
  Header,
  Heading,
  List,
  ListItem,
  TrackAnchor,
  Icon,
  BetaText,
  TrackButton
} from './style/ChatAssistantCard.css';
import { Check, SparkAIChatIcon } from '@usap/uicomponents';
import { GTM, openSparkChatModal } from "@usap/carparts/src/shared/helpers";
import { useSparkChatEnabled } from '@usap/carparts/src/shared/hooks';

const ChatAssistantCard = ({ chatAssistantData }) => {
  const { heading, list, cta, beta } = chatAssistantData;
  const isSparkChatEnabled = useSparkChatEnabled();

  const onTrackClick = (e) => {
    GTM.trackOrderWithSparkClickGTM();
    if(isSparkChatEnabled) {
      e.preventDefault();
      openSparkChatModal();
    } 
  };

  return (
    <Container>
      <Header>
        <Icon>
          <SparkAIChatIcon />
        </Icon>
          <Heading>{heading}</Heading>
      </Header>
      <List>
        {list.map((item, index) => (
          <ListItem key={index}><Check /> {item}</ListItem>
        ))}
      </List>
      {isSparkChatEnabled ?
        <TrackButton onClick={onTrackClick}>{cta}</TrackButton>
        :
        <TrackAnchor href="/chat" onClick={onTrackClick}>{cta}</TrackAnchor>
      }
      {beta && <BetaText>{beta}</BetaText>}
    </Container>
  );
};

export default ChatAssistantCard;
